<div class="flex flex-column">
    <span class="ruby bb fw5">{{ skill.category}}</span>
    <ul>
        <li *ngFor="let skill of skill.skills">{{ skill }}</li>
    </ul>
</div>